import { auth, firestore } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions();

export const GuruSSO = async () => {
  // A aba precisa ser aberta SÍNCRONA ao clique. Abrir o window.open só depois
  // dos await abaixo (getDoc + Cloud Function) faz o navegador tratá-lo como
  // popup e bloqueá-lo — o botão "carrega" mas nada abre. Abrimos a aba em
  // branco agora, no gesto do usuário, e apenas redirecionamos quando o token
  // chega.
  let newWindow = null;
  try {
    newWindow = window.open('about:blank', '_blank');
  } catch (_) {
    newWindow = null;
  }

  try {
    const id = auth?.currentUser?.uid;
    if (!id) {
      throw 'Usuário não encontrado';
    }
    const docRef = doc(firestore, "users", id);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      throw 'Usuário não encontrado';
    }

    const user = docSnap.data();

    if (!user.Email || user.Email == '') {
      throw 'E-mail de usuário inválido';
    }

    const guruSSOEventHandler = httpsCallable(functions, "guruSSOEventHandler");
    const response = JSON.parse((await guruSSOEventHandler({ email: user.Email })).data);

    if (!response.token) {
      throw 'Não foi encontrado token';
    }

    const targetUrl = `https://digitalmanager.guru/myorders/sso/${response.token}`;
    if (newWindow) {
      newWindow.location.href = targetUrl;
      newWindow.focus();
    } else {
      // Popup bloqueado mesmo assim: navega na própria aba como fallback.
      window.location.assign(targetUrl);
    }
  } catch (error) {
    if (newWindow) newWindow.close(); // fecha a aba em branco em caso de erro
    alert('Esse código de produto não foi encontrado na sua conta da Guru Digital');
    return;
  }
}

export const getProductById = async (id) => {
  if (!id || id === "") throw new Error("Por favor, informe o ID do produto");

  try {
    const guruGetProductsEventHandler = httpsCallable(functions, "guruGetProductsEventHandler");

    // Ligue debug temporariamente para provar paginação (desligue depois)
    const raw = await guruGetProductsEventHandler({ debug: true });

    const productsArrayResponse = JSON.parse(raw.data);

    const list = productsArrayResponse?.data || [];
    console.log("[Guru] total products recebidos:", list.length);

    if (list.length === 0) throw new Error("Lista de produtos está vazia");

    const product =
      list.find((item) => String(item.marketplace_id) === String(id)) ||
      list.find((item) => String(item.id) === String(id)); // fallback

    if (!product) {
      console.log("[Guru] exemplo marketplace_id (first 20):", list.slice(0, 20).map(p => p.marketplace_id));
      throw new Error("ID informado não foi encontrado nos produtos retornados pela API");
    }

    const guruGetOffersEventHandler = httpsCallable(functions, "guruGetOffersEventHandler");
    const offersArrayResponse = JSON.parse((await guruGetOffersEventHandler({ product: product.id })).data);

    if (!offersArrayResponse || offersArrayResponse?.length === 0) {
      throw new Error("Lista de ofertas está vazia");
    }

    return { product, offers: offersArrayResponse };
  } catch (err) {
    console.error("[Guru] getProductById falhou:", err);
    throw err; // <- essencial para você ver o erro na UI/logs
  }
};


export const generateCheckoutUrlWithParams = ({
  urlCheckout,
  name,
  email,
  phone,
  doc,
}) => (
  `${urlCheckout}?name=${name}&email=${email}&phone_number=${phone}&doc=${doc}`
)